import Pane from "./Pane"
import PaneBody from "./PaneBody"
import PaneHeader from "./PaneHeader"
import PaneFooter from "./PaneFooter"
import PaneTitle from "./PaneTitle"
import PaneBlankState from "./PaneBlankState"

Pane.Body = PaneBody
Pane.Header = PaneHeader
Pane.Footer = PaneFooter
Pane.Title = PaneTitle
Pane.BlankState = PaneBlankState

export default Pane
